if (!customElements.get('product-option-selector')) {
  customElements.define(
    'product-option-selector',
    class ProductOptionSelector extends HTMLElement {
      constructor() {
        super();

        this.optionsTitle = this.querySelector('.product-option-selector__options-title');
        /**
         * @type {NodeListOf<HTMLInputElement>}
         */
        this.radioButtons = this.querySelectorAll('input[type="radio"]');
        this.details = this.querySelector('.product-option-selector__options-details');
        this.container = document.querySelector('[js-product-options-selector-container]');
        this.openOnHover = this.dataset.openOnHover === 'true';

        this.radioButtons.forEach((radio) => {
          radio.addEventListener('click', this.handleClick.bind(this, radio));
        });

        if (!this.openOnHover) return;

        this.details?.addEventListener('mouseenter', () => {
          !this.isTouchDevice && this.details?.setAttribute('open', '');
        });

        this.containerElement?.addEventListener('mouseleave', () => {
          !this.isTouchDevice && this.details?.removeAttribute('open');
        });
      }

      /**
       *
       * @param {HTMLInputElement} radio
       */
      handleClick(radio) {
        if (!this.optionsTitle || !radio.dataset.value) return;

        this.optionsTitle.textContent = radio.dataset.value;
      }

      get key() {
        return this.getAttribute('key');
      }

      get containerElement() {
        const container = document.querySelector(`[js-product-options-selector-container-key="${this.key}"]`);

        return container ? container : this.details;
      }

      get isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      }
    },
  );
}
